export default {
    path: '/college',
    components: {
        default: () => import(/* webpackChunkName: "college" */ '../views/ChildContainer'),
        menu: () => import(/* webpackChunkName: "college-menu" */ '../views/college/Menu'),
    },
    children: [
        {
            path: '',
            name: 'CollegeHome',
            component: () => import(/* webpackChunkName: "college-home" */ '../views/Home'),
        },
        {
            path: 'info-edit',
            name: 'CollegeInfoEdit',
            component: () => import(/* webpackChunkName: "college-info-edit" */ '../views/college/CollegeInfoEdit'),
        },
        {
            path: 'studentManage',
            name: 'CollegeStudentManage',
            component: () => import(/* webpackChunkName: "college-student-manage" */ '../views/college/CollegeStudentManage'),
        },
        {
            path: 'studentSignInManage',
            name: 'CollegeStudentSignInManage',
            component: () => import(/* webpackChunkName: "college-student-manage" */ '../views/college/CollegeStudentSignInManage'),
        },
        {
            path: 'certificateDataManage',
            name: 'CollegeCertificateDataManage',
            component: () => import(/* webpackChunkName: "college-certificate-data-manage" */ '../views/college/CollegeCertificateDataManage'),
        },
    ]
}